import Vue from "vue";
import Vuex from "vuex";
import accountRecharge from './accountRecharge';
import consumeRecords from './consumeRecords';
import login from './login';
import myInfo from './myInfo';
import password from './password';
import result from './result';
import register from './register';
import cardList from './cardList';
import selectLoginWay from './selectLoginWay';
import qrCode from './qrCode';
Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		accountRecharge,
		consumeRecords,
		login,
		myInfo,
		password,
		result,
		register,
		cardList,
		selectLoginWay,
		qrCode
	}
})
